module.exports = __webpack_public_path__ + "img/06Mobilephone_SIM.702b76f6.png";